import { inject } from '@angular/core';
import { filter, pipe, switchMap } from 'rxjs';
import { tapResponse } from '@ngrx/operators';
import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';
import { rxMethod } from '@ngrx/signals/rxjs-interop';
import { AppConfigService } from './config.service';

type State = {
  exporting: boolean;
};

const initialState: State = {
  exporting: false,
};

export const ConfigStore = signalStore(
  { providedIn: 'root' },
  withState(initialState),
  withMethods((store, api = inject(AppConfigService)) => ({
    load: rxMethod<void>(
      pipe(
        filter(() => !store.exporting()),
        switchMap(() =>
          api.load().pipe(
            tapResponse({
              next: (status) => patchState(store, { exporting: status.exportEnabled }),
              error: () => patchState(store, { exporting: false }),
            }),
          ),
        ),
      ),
    ),
  })),
);
